<!--- https://xd.adobe.com/view/41de5214-2670-476f-9797-0f6909daa5af-148d/ -->
<template>
<main id="offerhistory">
    <div class="clearfix gibson mb2">
    <div class="col-12 p2">
        <div class="clearfix py3">
        <div class="clearfix">
            <div class="col-12 p0 m0">
            <div class="clearfix">
                <div class="col-12 px0">
                <p class="h4 semi-bold line-height-2 my2">Dine Tilbud</p>
                <p class="h5 regular darkblue gibson line-height-golden mb3 col-12 px0">
                    Dit overblik over alle tilbud du har sendt til dine kunder og potentielle kunder.Følg nemt op med kunder, der stagig ikke<br>
                    har reageret på dine tilbud.
                </p>
                </div>
            </div>
            <!-- largedesktop search input -->
            <div class="clearfix">
                <div class="col-12 px0">
                <div class="flex justify-start items-center py1 border muted-border mediumgrey shadow mb2">
                    <div class="flex-none px2">
                    <svg class="relative" style="top:3px;" width="18" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path class="st0" d="M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"/></svg>
                    </div>
                    <input class="searchBox gibson h4 darkblue regular mb0 p2 pl0" type="search" name="search" v-model="search" placeholder="Søg efter" style="background:transparent;">
                    <!-- <input type="submit" value="Search" class="searchButton"> -->
                </div>
                </div>
                <!-- large desktop filter -->
                <div class="col-12 px0 flex justify-start items-center mt3 mb2">
                <div class="col-6 pr1 pl0">
                    <button v-b-toggle.webCustomers class="col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center">
                    <span class="h5 mb0">Sortér</span>
                    <span class="relative ml2" style="top:4px;">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                    </button>
                </div>
                <div class="col-6 px0">
                    <button v-b-toggle.m2mtilbud class="col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center">
                    <span class="h5 mb0 mr2">Filter</span>
                    <span class="when-closed">
                        <span class="relative" style="top:3px;">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                        </span>
                    </span>
                    <span class="flex-none when-opened">
                        <span class="relative" style="top:3px;">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                        </span>
                    </span>
                    </button>
                </div>
                </div>
            </div>
            </div>
            <b-collapse id="m2mtilbud" class="lg-col-6 md-col-6 sm-col-10 right">
            <div class=" my3">
                <div class="col-9 px0 flex justify-between items-center">
                <p class="h5 darkblue gibson line-height-3">
                    Vælg
                </p>
                <button v-b-toggle.m2mtilbud class="white-button border-none not-rounded gibson">
                    <span>
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>
                    </span>
                </button>
                </div>
                <div class="py1"></div>
                <!-- <b-form-checkbox id="sortByDate" v-model="status" name="sortByDate" value="accepted" unchecked-value="not_accepted">
                <span class="ml1 h6 regular relative" style="top:-3px;">Mester-til-Mester</span>
                </b-form-checkbox> -->
                <div class="col-12 px0 flex flex-wrap justify-start items-center my2">
                          <div class="flex flex-column col-12 mx-auto mb2" >
                          <p class="h5 semi-bold">kunder</p>
                          <div class="flex flex-wrap ">
                            <b-form-checkbox :id="item+index" v-model="customerfilter" v-for="(item,index) in allcustomerfilter" :key="index" :name="item+index" :value="item" class="col-3 p0" >
                            <span class=" h6 regular" style="top:-3px;">{{item}}</span>
                            </b-form-checkbox>
                          </div>
                          </div>
                </div>
            </div>
            </b-collapse>
            <b-collapse id="webCustomers" class="col-6">
            <div class="clearfix my3">
                <div class="col-9 px0 flex justify-between items-center">
                <p class="h5 darkblue gibson line-height-3">
                    Tilpas rækkefølgen
                </p>
                <button v-b-toggle.webCustomers class="white-button border-none not-rounded gibson">
                    <span>
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>
                    </span>
                </button>
                </div>
                <div class="col-12 px0 flex flex-wrap justify-start items-center my2">
                    <b-form-group :value.sync="statusDate" v-slot="{ ariaDescribedby }">
                        <b-form-radio-group >
                          <b-form-radio id="sortByDatexxl" v-model="statusDate" :aria-describedby="ariaDescribedby" name="sortByDatexxl" value="1" >
                            <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter mødedato</span>
                          </b-form-radio>
                          <div class="clearfix"></div>
                          <b-form-radio id="sortByStatusxxl" v-model="statusDate" :aria-describedby="ariaDescribedby" name="sortByStatusxxl" value="2" >
                            <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter status</span>
                          </b-form-radio>
                          <div class="clearfix"></div>
                          <b-form-radio id="offerSentxxl" v-model="statusDate" :aria-describedby="ariaDescribedby" name="offerSentxxl" value="3" >
                            <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter sendt tilbud dato</span>
                          </b-form-radio>
                          <div class="clearfix"></div>
                          <b-form-radio id="followUpxxl" v-model="statusDate" :aria-describedby="ariaDescribedby" name="followUpxxl" value="4" >
                            <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter opfølgningsdato</span>
                          </b-form-radio>
                        </b-form-radio-group>
                  </b-form-group>
                </div>
            </div>
            </b-collapse>
            <div class="flex flex-column col-12 p0 m0 my2">
            <p class="col-12 h5 semi-bold darkblue p0">Oversigt over dine kunder om året</p>
            <div class="flex flex-wrap flex-mobile-center">
            <button @click="filteryear(item)" :id="'yearfilter-' + item" class="primary-button-green pointer regular h5 white p2 mr1" style="width:120px" v-for="(item,index) in allyear" :key="index">{{item}}
            </button>
            <button @click="filterminbolig()" id="minbolig2" v-if="filteredItemsbitrix.length > 0" class="primary-button-green pointer regular h5 white p2 mr1" style="width:120px">Minbolig
            </button>
            </div>
            </div>
        </div>
        </div>
    </div>
    </div>
<!-- loader -->
<div class="clearfix">
    <div class="col-12" v-if="loading">
    <div class="loader"></div>
    </div>
</div>
<div class=" flex flex-wrap md-col-12 sm-col-12 justify-center items-stretch" >
    <div class="flex items-stretch relative border muted-border p2 py3 shadow mb3 mr1" style="width:300px;" v-for="item in SearchItem" :key="item.id">
    <div class="flex flex-column col-12">
        <div class=" semi-bold ">
            <p class="flex items-center"><span class="mr1 flex items-center"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg></span>
                <span v-html="item.firstname + ' ' + item.lastname"></span>
            </p>
            <p class="flex items-center"><span class="mr1 flex items-center"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg></span>
                <span>{{item.address}}</span>
            </p>
            <p class="flex items-center"><span class="mr1 flex items-center"><svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -3 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-calendar-alt"><path d="M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"></path></svg></span>
                <span>{{moment(item.createdtime).locale('da').format('LL')}}</span>
            </p>
        </div>
        <div class="semi-bold">
            <button @click="showpdfoffer(item.offerfile)" class="col-12 outlined-primary-button p2 flex justify-center items-center gibson line-height-1 my1">
                <p class="semi-bold primary m0">Se Tilbud</p>
            </button>
            <a :href="'tel:' + item.mobile" class="col-12 outlined-action-button p2 flex justify-center items-center gibson line-height-1 my1">
                <span class="relative mr2"><svg fill="currentColor" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M492.6 400.6L392.2 300.2c-12-12-31.5-12-43.4 0l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2l-9.8 9.8c0 0 0 0 0 0 -7 7-50.5-3.7-103.1-56.4 -52.6-52.6-63.4-96.1-56.4-103.1 0 0 0 0 0 0l9.9-9.9c2.8 0.8 5.7 1.2 8.5 1.2 7.9 0 15.7-3 21.7-9l26.1-26.1c12-12 12-31.5 0-43.4L111.4 19.4c-5.8-5.8-13.5-9-21.7-9 -8.2 0-15.9 3.2-21.7 9l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2 0 0-8.3 8.4-8.8 9 -27.8 30.8-33 79.4-14.6 137.5 18 56.9 56.9 117.1 109.4 169.6 52.5 52.5 112.7 91.3 169.6 109.4C312.6 508.4 334 512 353.4 512c31.8 0 58.3-9.6 77.4-28.7l5.5-5.5c2.7 0.8 5.6 1.2 8.5 1.2 8.2 0 15.9-3.2 21.7-9l26.1-26.1C504.5 432 504.5 412.5 492.6 400.6zM89.7 41.2l100.3 100.3 -26.1 26.1c0 0 0 0 0 0l-0.4-0.4 -49.8-49.8L63.6 67.2 89.7 41.2zM409 461.6c0 0 0 0 0 0 -22.1 22.1-61.1 25.7-110 10.3 -52.3-16.6-108.1-52.7-157.2-101.8C92.8 321 56.7 265.2 40.1 212.9c-15.5-48.8-11.8-87.9 10.3-110l0 0 2.8-2.8 77.9 77.9 -7.1 7.1c0 0 0 0 0 0 -29.6 29.6 6 96.1 56.4 146.6 37.7 37.7 84.5 67.1 118.1 67.1 11.3 0 21.1-3.3 28.5-10.8 0 0 0 0 0 0l7.1-7.1 77.9 77.9L409 461.6zM444.8 448.4L344.4 348l26.1-26.1L470.8 422.3C470.8 422.3 444.8 448.4 444.8 448.4z"></path><path d="M388.8 123.2c-29.2-29.2-68-45.3-109.3-45.3 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 33.1 0 64.2 12.9 87.6 36.3 23.4 23.4 36.3 54.5 36.3 87.6 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C434.1 191.2 418 152.4 388.8 123.2z"></path><path d="M443.9 68.1C400 24.2 341.6 0 279.5 0c-8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 53.9 0 104.6 21 142.7 59.1 38.1 38.1 59.1 88.8 59.1 142.7 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C512 170.4 487.8 112 443.9 68.1z"></path><path d="M333.7 178.3c-14.7-14.7-33.5-22.5-54.3-22.5 0 0 0 0 0 0 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 0 0 0 0 0 0 12.6 0 23.6 4.5 32.5 13.5 8.8 8.8 13.5 20.1 13.5 32.5 0 8.5 6.9 15.4 15.4 15.4h0c8.5 0 15.4-6.9 15.4-15.4C356.2 211.7 348.4 193 333.7 178.3z"></path></svg></span>
                <span class="h6 line-height-1 mb0 semi-bold ">Ring {{item.mobile}}</span>
            </a>
            <button @click="mailSupport(item.cid)" class="col-12 outlined-action-button p2 flex justify-center items-center gibson line-height-1 my1">
                <p class="relative mr2 m0"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -3 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-calendar-alt"><path d="M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"></path></svg></p>
                <p class="h6 line-height-1 mb0 semi-bold ">Skriv til kunden</p>
            </button>
        </div>
        <div>
            <b-form-select id="statusSelect" v-model="item.sent"  class="col-12 muted-background border-none darkblue semi-bold pl2 not-rounded gibson mb0" style="height:48px;font-size:18.5px!important;">
                <template #first>
                    <b-form-select-option :value="item.sent" v-if="item.sent === '1'">Ikke sendt</b-form-select-option>
                    <b-form-select-option :value="item.sent" v-if="item.sent === '0'">Sendt</b-form-select-option>
                </template>
            </b-form-select>
        </div>
        <div>
            <button v-b-toggle="'setReminder'+item.reference_number" class="p1 col-12 flex gibson outlined-standard-button not-rounded border-none justify-start items-center">
                <p class="relative mr2 m0"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-3 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-bell"><path d="M13.666 11.782L13 11.186V6a4 4 0 1 0-8 0v5.186l-.666.596A6.987 6.987 0 0 0 2.29 15h13.42a6.987 6.987 0 0 0-2.044-3.218zM12 17a3 3 0 0 1-6 0H0a8.978 8.978 0 0 1 3-6.708V6a6 6 0 1 1 12 0v4.292A8.978 8.978 0 0 1 18 17h-6zm-3 1a1 1 0 0 0 1-1H8a1 1 0 0 0 1 1z"></path></svg></p>
                <p class="h6 line-height-1 mb0 semi-bold ">Tilføj påmindelse</p>
            </button>
        </div>
        <b-collapse :id="'setReminder'+item.reference_number" ref="reminderModal" class="col-12">
            <form @submit.stop.prevent="handleSubmitReminder(item)">
              <div class="clearfix mb3">
                <div class="flex flex-column my2">
                  <span class="h6 semi-bold gibson darkblue block mb1" style="font-size:13.5px;">Type</span>
                  <select id="reminderSelect"  required  class="muted-background p1 darkblue not-rounded border-none gibson mb1" style="font-size:16.5px;height:38px;">
                    <option value="1">SMS og email</option>
                    <option value="2">SMS</option>
                    <option value="3">Email</option>
                    <option value="0">None</option>
                  </select>
                </div>
                <div class="flex flex-column mt3 mb2">
                  <span class="h6 semi-bold gibson darkblue block mb1" style="font-size:13.5px;">Dato</span>
                  <VueCtkDateTimePicker id="reminderDate" v-model="datereminder" locale="da" label="Påmindelse Dato" required placeholder="Påmindelse Dato" class="darkblue not-rounded border-none gibson mb1 muted-background"  />
                </div>
                <div class="flex flex-column mb2">
                  <span class="h6 semi-bold gibson darkblue block mb1" style="font-size:13.5px;">Noter</span>
                  <textarea name="note"   id="note" cols="30" rows="5" required placeholder="" class="p2 muted-background darkblue gibson line-height-3 border-none not-rounded" style="font-size:13.5px;"></textarea>
                </div>
                <div class="clearfix flex flex-column items-center">
                  <div class="col-12 px0">
                    <button v-b-toggle.newclass  class="col-12 action-button p2 line-height-1 flex justify-center items-center border-none not-rounded gibson">
                      <span class="semi-bold" style="font-size:16.5px;">Gem</span>
                      <span class="ml1"><i class="el-icon-right"></i></span>
                    </button>
                  </div>
                  <div class="py1"></div>
                  <div class="col-12 px0">
                    <button type="button" v-b-toggle="'setReminder'+item.apreference_numberpid"  class="col-12 outlined-disabled-button p2 gibson line-height-1 flex justify-center items-center not-rounded">
                      <span class="pr2"><i class="el-icon-back"></i></span>
                      <span style="font-size:16.5px;">Luk påmindelse</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
        </b-collapse>
          <div v-if="item.bilagfile_new.length > 0">
            <button v-b-toggle="'bilagfiles'+item.reference_number" class="p1 col-12 flex gibson outlined-standard-button not-rounded border-none justify-start items-center">
                <p class="relative mr2 m0"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="24" viewBox="0 0 34 40" class="offerbilagicon">
                <path id="uploaded_file" data-name="uploaded file" d="M3,40a3,3,0,0,1-3-3V24a1,1,0,1,1,2,0V37a1,1,0,0,0,1,1H27a1,1,0,0,0,1-1V36H7a3,3,0,0,1-3-3V6H3A1,1,0,0,0,2,7v5a1,1,0,0,1-2,0V7A3,3,0,0,1,3,4H4V3A3,3,0,0,1,7,0H21.66A3,3,0,0,1,23.8.9l9.34,9.56A2.931,2.931,0,0,1,34,12.55V33a3,3,0,0,1-3,3H30v1a3,3,0,0,1-3,3ZM6,3V33a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V13H25a3,3,0,0,1-3-3V2.07A1,1,0,0,0,21.66,2H7A1,1,0,0,0,6,3Zm18,7a1,1,0,0,0,1,1h5.88L24,4ZM18,29V18.41l-3.29,3.3a1,1,0,1,1-1.419-1.42l5-5a1,1,0,0,1,1.42,0l5,5a1,1,0,1,1-1.42,1.42L20,18.41V29a1,1,0,0,1-2,0ZM0,18a1,1,0,1,1,1,1A1,1,0,0,1,0,18Z"/></svg></p>
                <p class="h6 line-height-1 mb0 semi-bold ">Bilag</p>
            </button>
          </div>
          <div class="flex justify-start" style="height: 48px;" v-else>
            <span class="mr2 ml1 flex items-center ">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="24" viewBox="0 0 34 40">
                <path id="uploaded_file" data-name="uploaded file" d="M3,40a3,3,0,0,1-3-3V24a1,1,0,1,1,2,0V37a1,1,0,0,0,1,1H27a1,1,0,0,0,1-1V36H7a3,3,0,0,1-3-3V6H3A1,1,0,0,0,2,7v5a1,1,0,0,1-2,0V7A3,3,0,0,1,3,4H4V3A3,3,0,0,1,7,0H21.66A3,3,0,0,1,23.8.9l9.34,9.56A2.931,2.931,0,0,1,34,12.55V33a3,3,0,0,1-3,3H30v1a3,3,0,0,1-3,3ZM6,3V33a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V13H25a3,3,0,0,1-3-3V2.07A1,1,0,0,0,21.66,2H7A1,1,0,0,0,6,3Zm18,7a1,1,0,0,0,1,1h5.88L24,4ZM18,29V18.41l-3.29,3.3a1,1,0,1,1-1.419-1.42l5-5a1,1,0,0,1,1.42,0l5,5a1,1,0,1,1-1.42,1.42L20,18.41V29a1,1,0,0,1-2,0ZM0,18a1,1,0,1,1,1,1A1,1,0,0,1,0,18Z" fill="#003645"/>
              </svg>
            </span>
            <p class="h6 gibson darkblue line-height-1 mb0 semi-bold flex items-center ">Ingen filer uploadet</p>
          </div>
          <b-collapse :id="'bilagfiles'+item.reference_number" class="">
            <!-- eslint-disable -->
            <div class="mb1 h6 p1 darkblue " v-for="(file,index) in item.bilagfile_new" :key="file.id" v-if="item.bilagfile_new.length > 0">
              <a type="button" class="semi-bold" :href="encodeURI(file.url)" target="_blank">Fil {{parseInt(index + 1)}}</a>
            </div>
            <!-- eslint-enable -->
            </b-collapse>
          <p class="flex ml-auto"><i @click="deletedrafttilbud(item)" class="red h5 el-icon-delete pointer"></i></p>
    </div>
    </div>
    <!-- eslint-disable -->
    <div class="flex items-stretch relative border muted-border p2 py3 shadow mb3 mr1" style="width:300px;" v-for="item in filteredItemsbitrix" :key="item.ID" v-if="showboligoffer">
      <div class="flex flex-column col-12">
        <div class=" semi-bold ">
            <p class="flex items-center"><span class="mr1 flex items-center"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg></span>
                <span v-html="item.TITLE"></span>
            </p>
            <p class="flex items-center"><span class="mr1 flex items-center"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg></span>
                <span>{{item.DESCRIPTION}}</span>
            </p>
            <p class="flex items-center"><span class="mr1 flex items-center"><svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -3 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-calendar-alt"><path d="M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"></path></svg></span>
                <span>{{moment(item.CREATED_AT).locale('da').format('LL')}}</span>
            </p>
        </div>
        <div class="semi-bold">
            <button @click="getAcceptedOfferPrice(item.ID, item.PROJECT_ID, item.CONTACT_ID)" class="col-12 outlined-primary-button p2 flex justify-center items-center gibson line-height-1 my1">
                <p class="semi-bold primary m0">Se Tilbud</p>
            </button>
            <a :href="'tel:' + item.CONTACT_ID" class="col-12 outlined-action-button p2 flex justify-center items-center gibson line-height-1 my1">
                <span class="relative mr2"><svg fill="currentColor" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M492.6 400.6L392.2 300.2c-12-12-31.5-12-43.4 0l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2l-9.8 9.8c0 0 0 0 0 0 -7 7-50.5-3.7-103.1-56.4 -52.6-52.6-63.4-96.1-56.4-103.1 0 0 0 0 0 0l9.9-9.9c2.8 0.8 5.7 1.2 8.5 1.2 7.9 0 15.7-3 21.7-9l26.1-26.1c12-12 12-31.5 0-43.4L111.4 19.4c-5.8-5.8-13.5-9-21.7-9 -8.2 0-15.9 3.2-21.7 9l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2 0 0-8.3 8.4-8.8 9 -27.8 30.8-33 79.4-14.6 137.5 18 56.9 56.9 117.1 109.4 169.6 52.5 52.5 112.7 91.3 169.6 109.4C312.6 508.4 334 512 353.4 512c31.8 0 58.3-9.6 77.4-28.7l5.5-5.5c2.7 0.8 5.6 1.2 8.5 1.2 8.2 0 15.9-3.2 21.7-9l26.1-26.1C504.5 432 504.5 412.5 492.6 400.6zM89.7 41.2l100.3 100.3 -26.1 26.1c0 0 0 0 0 0l-0.4-0.4 -49.8-49.8L63.6 67.2 89.7 41.2zM409 461.6c0 0 0 0 0 0 -22.1 22.1-61.1 25.7-110 10.3 -52.3-16.6-108.1-52.7-157.2-101.8C92.8 321 56.7 265.2 40.1 212.9c-15.5-48.8-11.8-87.9 10.3-110l0 0 2.8-2.8 77.9 77.9 -7.1 7.1c0 0 0 0 0 0 -29.6 29.6 6 96.1 56.4 146.6 37.7 37.7 84.5 67.1 118.1 67.1 11.3 0 21.1-3.3 28.5-10.8 0 0 0 0 0 0l7.1-7.1 77.9 77.9L409 461.6zM444.8 448.4L344.4 348l26.1-26.1L470.8 422.3C470.8 422.3 444.8 448.4 444.8 448.4z"></path><path d="M388.8 123.2c-29.2-29.2-68-45.3-109.3-45.3 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 33.1 0 64.2 12.9 87.6 36.3 23.4 23.4 36.3 54.5 36.3 87.6 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C434.1 191.2 418 152.4 388.8 123.2z"></path><path d="M443.9 68.1C400 24.2 341.6 0 279.5 0c-8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 53.9 0 104.6 21 142.7 59.1 38.1 38.1 59.1 88.8 59.1 142.7 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C512 170.4 487.8 112 443.9 68.1z"></path><path d="M333.7 178.3c-14.7-14.7-33.5-22.5-54.3-22.5 0 0 0 0 0 0 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 0 0 0 0 0 0 12.6 0 23.6 4.5 32.5 13.5 8.8 8.8 13.5 20.1 13.5 32.5 0 8.5 6.9 15.4 15.4 15.4h0c8.5 0 15.4-6.9 15.4-15.4C356.2 211.7 348.4 193 333.7 178.3z"></path></svg></span>
                <span class="h6 line-height-1 mb0 semi-bold ">Ring</span>
            </a>
            <button @click="seeMessages(item.CONTACT_ID)" class="col-12 outlined-action-button p2 flex justify-center items-center gibson line-height-1 my1">
                <p class="relative mr2 m0"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -3 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-calendar-alt"><path d="M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"></path></svg></p>
                <p class="h6 line-height-1 mb0 semi-bold ">Skriv til kunden</p>
            </button>
        </div>
        <div>
            <b-form-select id="statusSelect" v-model="item.sent"  class="col-12 muted-background border-none darkblue semi-bold pl2 not-rounded gibson mb0" style="height:48px;font-size:18.5px!important;">
                <template #first>
                    <b-form-select-option :value="item.sent">{{item.STATUS}}</b-form-select-option>
                </template>
            </b-form-select>
        </div>
        <!-- <div> no functions for this bitrix
            <button v-b-toggle="'setReminder'+item.ID" class="p1 col-12 flex gibson outlined-standard-button not-rounded border-none justify-start items-center">
                <p class="relative mr2 m0"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-3 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-bell"><path d="M13.666 11.782L13 11.186V6a4 4 0 1 0-8 0v5.186l-.666.596A6.987 6.987 0 0 0 2.29 15h13.42a6.987 6.987 0 0 0-2.044-3.218zM12 17a3 3 0 0 1-6 0H0a8.978 8.978 0 0 1 3-6.708V6a6 6 0 1 1 12 0v4.292A8.978 8.978 0 0 1 18 17h-6zm-3 1a1 1 0 0 0 1-1H8a1 1 0 0 0 1 1z"></path></svg></p>
                <p class="h6 line-height-1 mb0 semi-bold ">Tilføj påmindelse</p>
            </button>
        </div> -->
        <b-collapse :id="'setReminder'+item.ID" ref="reminderModal" class="col-12">
            <form @submit.stop.prevent="handleSubmitReminder(item)">
              <div class="clearfix mb3">
                <div class="flex flex-column my2">
                  <span class="h6 semi-bold gibson darkblue block mb1" style="font-size:13.5px;">Type</span>
                  <select id="reminderSelect"  required  class="muted-background p1 darkblue not-rounded border-none gibson mb1" style="font-size:16.5px;height:38px;">
                    <option value="1">SMS og email</option>
                    <option value="2">SMS</option>
                    <option value="3">Email</option>
                    <option value="0">None</option>
                  </select>
                </div>
                <div class="flex flex-column mt3 mb2">
                  <span class="h6 semi-bold gibson darkblue block mb1" style="font-size:13.5px;">Dato</span>
                  <VueCtkDateTimePicker id="reminderDate" v-model="datereminder" locale="da" label="Påmindelse Dato" required placeholder="Påmindelse Dato" class="darkblue not-rounded border-none gibson mb1 muted-background"  />
                </div>
                <div class="flex flex-column mb2">
                  <span class="h6 semi-bold gibson darkblue block mb1" style="font-size:13.5px;">Noter</span>
                  <textarea name="note"   id="note" cols="30" rows="5" required placeholder="" class="p2 muted-background darkblue gibson line-height-3 border-none not-rounded" style="font-size:13.5px;"></textarea>
                </div>
                <div class="clearfix flex flex-column items-center">
                  <div class="col-12 px0">
                    <button v-b-toggle.newclass  class="col-12 action-button p2 line-height-1 flex justify-center items-center border-none not-rounded gibson">
                      <span class="semi-bold" style="font-size:16.5px;">Gem</span>
                      <span class="ml1"><i class="el-icon-right"></i></span>
                    </button>
                  </div>
                  <div class="py1"></div>
                  <div class="col-12 px0">
                    <button type="button" v-b-toggle="'setReminder'+item.apreference_numberpid"  class="col-12 outlined-disabled-button p2 gibson line-height-1 flex justify-center items-center not-rounded">
                      <span class="pr2"><i class="el-icon-back"></i></span>
                      <span style="font-size:16.5px;">Luk påmindelse</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </b-collapse>

          <div class="flex justify-start" style="height: 48px;">
            <span class="mr2 ml1 flex items-center ">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="24" viewBox="0 0 34 40">
                <path id="uploaded_file" data-name="uploaded file" d="M3,40a3,3,0,0,1-3-3V24a1,1,0,1,1,2,0V37a1,1,0,0,0,1,1H27a1,1,0,0,0,1-1V36H7a3,3,0,0,1-3-3V6H3A1,1,0,0,0,2,7v5a1,1,0,0,1-2,0V7A3,3,0,0,1,3,4H4V3A3,3,0,0,1,7,0H21.66A3,3,0,0,1,23.8.9l9.34,9.56A2.931,2.931,0,0,1,34,12.55V33a3,3,0,0,1-3,3H30v1a3,3,0,0,1-3,3ZM6,3V33a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V13H25a3,3,0,0,1-3-3V2.07A1,1,0,0,0,21.66,2H7A1,1,0,0,0,6,3Zm18,7a1,1,0,0,0,1,1h5.88L24,4ZM18,29V18.41l-3.29,3.3a1,1,0,1,1-1.419-1.42l5-5a1,1,0,0,1,1.42,0l5,5a1,1,0,1,1-1.42,1.42L20,18.41V29a1,1,0,0,1-2,0ZM0,18a1,1,0,1,1,1,1A1,1,0,0,1,0,18Z" fill="#003645"/>
              </svg>
            </span>
            <p class="h6 gibson darkblue line-height-1 mb0 semi-bold flex items-center ">Ingen filer uploadet</p>
          </div>
      </div>
    </div>
    <!-- eslint-enable -->
</div>
<b-modal  size="lg" ref="seeoffer" v-model="seeoffer" centered id="seeoffer"  title="Hent vejledning her" ok-only allowfullscreen>
        <b-embed type="iframe" scrolling="no" :src="urlofferpdf"   aspect="1by1"  allowfullscreen ></b-embed>
        <div slot="modal-footer" class="py-4 px-4 d-flex justify-content-between w-100">
        <b-btn type="reset" variant="outline-dark" size="lg"  @click="hidepdfoffer" class="float-left">Luk
        </b-btn>
        </div>
</b-modal>
<b-modal hide-footer size="lg" ref="seeselectedoffer" v-model="seeselectedoffer" centered id="seeselectedoffer"  title="Hent vejledning her">
  <div class="col-12 flex justify-end items-center white-background px0 ">
    <button type="button" class="white-button no-border not-rounded gibson " @click="closemodaloffer()">
      <span> <i class="el-icon-circle-close"></i> </span>
    </button>
  </div>
  <div class="clearfix" v-if="innerloading">
    <Loading></Loading>
  </div>
  <div class="" v-else>
    <p class="h4 semi-bold py2 m0 ">Tilbudsliste</p>
    <div class="overflow-auto p2" style="height: 600px;">
      <div class="flex flex-column mb2 pr2" v-for="(industryfields,index) in Object.keys(selectedArr)" :key="index">
        <p class="m0 p0 h4 my1">{{parseInt(index + 1) + '. '}}{{itemsjobindustry[industryfields]}}</p>
          <div v-for="(jobitem,index2) in selectedArr[industryfields]" :key="index2">
            <div class="flex items-center">
              <p class="m0 pl3 h4 xs-pl1 my1">{{parseInt(index + 1) + '.'}}{{index2 + 1 + ' '}}{{primaryproductindustryname[jobitem['INDUSTRY']]}}</p>
              <div class="m0 p0 lg-col-1 md-col-1 xs-col-5 sm-col-1 ml-auto ">
                <p>{{(parseInt(jobitem['TOTALVAT'])).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})}}</p>
              </div>
            </div>
            <div  v-for="(itemfields,index3) in jobitem.SERIES" :key="index3">
              <div class="m0 p0 pr2 mp0 lg-col-9 md-col-9 xs-col-12 sm-col-9 mr-auto">
                <div class="m0 pl4 xs-pl2 flex">
                  <span class="">{{parseInt(index + 1) + '.' + parseInt(index2 + 1) + '.' + parseInt(index3 + 1)}}</span>
                  <div class="pl1">{{itemfields}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-column col-11 px0 mx-auto border muted-border border-bottom-0 my3 border-left-0  border-right-0 pl2">
          <div class="h6 flex my1 p0 col-12"><p class="m0 p0 col-4">Totalpris inkl. 25 % moms</p><p class="m0 p0 col-8 flex justify-end">{{(parseInt(totaloffer)).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})}}</p></div>
        </div> 
    </div>
  </div>
</b-modal>
<!-- <loading :show="show" :label="label" :overlay="overlay"></loading> -->
<simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
<noneligibleFeaturepop ref="noneligibleFeaturepop"></noneligibleFeaturepop>
<ErrorHandler ref="errorMsg"></ErrorHandler>
</main>
</template>
<script>
// import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import fileUploadInput from '../../components/file-upload-input'
import VueGallerySlideshow from 'vue-gallery-slideshow'
import { Datetime } from 'vue-datetime'
import Countdown from '../../components/Countdown'
import Countdown2 from '../../components/Countdown2'
import datePicker from 'vue-bootstrap-datetimepicker'
import noneligibleFeaturepop from './noneligibleFeaturepop'
const Loading = () => import('@/components/Loading')
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  name: 'alltilbudhistory',
  components: {
    // loading,
    Loading,
    Countdown,
    Countdown2,
    fileUploadInput,
    VueGallerySlideshow,
    datetime: Datetime,
    Simplert,
    datePicker,
    noneligibleFeaturepop,
    ErrorHandler
  },
  created () {
    // Fagentreprise
    // Hovedentreprise
    this.gettaskbitrix()
    this.getallwizardproduct()
    this.klimaprofil = localStorage.getItem('ClimatePartner')
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.customerid = this.$route.query.app
    this.minboligv2 = this.$route.query.from
    this.customerfilterfromtable = this.customerid
    this.parentID = this.$route.query.parentID ? this.$route.query.parentID : null
    this.offerID = this.$route.query.offerid ? this.$route.query.offerid : null
    this.jobList = this.$route.query.joblist ? JSON.parse(this.$route.query.joblist) : []
    this.contractType = this.$route.query.contracttype ? this.$route.query.contracttype : null
    this.projectID = this.$route.query.projectID ? this.$route.query.projectID : null
    this.createdFrom = this.$route.query.createdfrom ? this.$route.query.createdfrom : null
    this.projectTitle = this.$route.query.projecttitle ? this.$route.query.projecttitle : null
    this.childprojects = this.$route.query.childprojects ? JSON.parse(this.$route.query.childprojects) : null
    if (this.offerID) {
      if (this.contractType === 'Fagentreprise') {
        this.getAcceptedOfferPrice(this.offerID, this.parentID, this.customerid)
      } else {
        this.getAcceptedOfferPrice(this.offerID, this.projectID, this.customerid)
      }
    }
    this.getyearsarray()
    setTimeout(() => {
      this.getallminboligoffers()
    }, 400)
  },
  data () {
    return {
      maintilbudstatus: '',
      disableStatusSelection: false,
      urlofferpdf: '',
      items: [],
      kundeitem: [],
      status: [],
      klimaprofil: '',
      SearchItem: [],
      files: [],
      statusDate: '',
      commentId: '',
      show: false,
      upload_token: '',
      clear_quotation_attachment: false,
      tilbud_id: '',
      index: null,
      modalShowPris: false,
      datereminder: null,
      label: 'Loading...',
      AflyseText: '',
      search: '',
      CommentText: '',
      AflyseTexttitle: '',
      Aflysetitle: '',
      Datosetitle: '',
      dateDato: '',
      timeDato: '',
      Aflyseid: '',
      Datoeid: '',
      komments: [],
      CommentCustomerText: '',
      textAflyseReason: '',
      textDatoReason: '',
      isLoadingAflyse: true,
      isLoadingDato: false,
      overlay: true,
      send_email: true,
      meetingShow: false,
      modalShowAflyseText: false,
      modalShowCommentText: false,
      modalShowCommentCustomerText: false,
      modalShowAflyse: false,
      modalShowDato: false,
      loading: true,
      salesPerson: '',
      salesPersonbitrix: '',
      filteredItemsbitrix: [],
      showboligoffer: false,
      haaId: '',
      oldestFirst: false,
      modalPriceFeedback: false,
      modalSurvey: false,
      surveyDescription: '',
      statusItem: [],
      statusValue: '',
      feedbackLoading: true,
      statusConfirmation: false,
      allyear: [],
      activeyear: '',
      customers: [],
      allcustomerfilter: [],
      customerfilter: [],
      customerfilterfromtable: '',
      customerid: '',
      allcustomerinfo: '',
      minboligv2: '',
      openjobs: [],
      seeoffer: false,
      selectedArr: {},
      parentID: '',
      jobList: [],
      contractType: '',
      projectID: '',
      createdFrom: '',
      projectTitle: '',
      childprojects: [],
      offerID: '',
      seeselectedoffer: false,
      itemsjobindustry: {},
      primaryproductindustryname: {},
      totaloffer: 0,
      innerloading: false
    }
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix
      } else {
        return text
      }
    }
  },
  watch: {
    'search': function (newVal, oldVal) {
      setTimeout(() => {
        this.updateSearch('searc')
      }, 200)
      this.SearchItem = []
    },
    'customerfilter': function (newVal, oldVal) {
      setTimeout(() => {
        this.updateSearch(this.customerfilter)
      }, 200)
    },
    'customerfilterfromtable': function (newVal, oldVal) {
      setTimeout(() => {
        this.updateSearchcustomer(this.customerid)
      }, 200)
    }
  },
  computed: {
  },
  methods: {
    getyearsarray () {
      var initialyear = 2018
      var latestyear = new Date().getFullYear()
      for (var i = initialyear; i <= latestyear; i++) {
        this.allyear.push(initialyear)
        initialyear++
      }
      this.allyear.reverse()
      this.getalladdress()
    },
    filteryear (year) {
      this.showboligoffer = false
      if (document.getElementById('minbolig2') !== null) {
        document.getElementById('minbolig2').classList.add('primary-button-green')
      }
      if (this.activeyear !== '') {
        var oldyear = this.activeyear
        document.getElementById('yearfilter-' + oldyear).classList.add('primary-button-green')
        document.getElementById('yearfilter-' + oldyear).classList.remove('green-background')
      }
      this.activeyear = year
      document.getElementById('yearfilter-' + year).classList.add('green-background')
      document.getElementById('yearfilter-' + year).classList.remove('primary-button-green')
      var itemsyear = []
      var filteredyear = []
      itemsyear = this.items.filter((item) => {
        var createditemyear = new Date(item.createdtime).getFullYear()
        if (createditemyear === year) {
          return item.createdtime
        }
      })
      itemsyear.forEach(function (value) {
        filteredyear.push(value)
      })
      this.SearchItem = this.filterSearch(filteredyear)
    },
    getalladdress () {
      this.loading = true
      var cid = this.$route.query.id
      var data = {operation: 'oversigt_partner', salesPerson: this.salesPerson, typeMeeting: '1', cid: cid}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.allcustomerinfo = res.array
            this.Reload()
          },
          response => {
            this.$message({
              type: 'error',
              message: response.body.message
            })
          })
    },
    getallminboligoffers () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/offers', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          if (response.body.success) {
            this.filteredItemsbitrix = res
            this.openjobs = res
          } else {
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        },
        response => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    refreshtoken () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers }, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN)
              this.salesPerson = res.data.NEW_TOKEN
            } else {
              console.log('something is wrong with refreshing the token')
              this.$router.push('/login')
            }
          },
          response => {
            console.log('something is wrong with refreshing the token')
            this.$router.push('/login')
          }
        )
    },
    filterminbolig () {
      this.showboligoffer = true
      this.allyear.forEach(a => {
        document.getElementById('yearfilter-' + a).classList.remove('green-background')
        document.getElementById('yearfilter-' + a).classList.add('primary-button-green')
      })
      document.getElementById('minbolig2').classList.remove('primary-button-green')
      document.getElementById('minbolig2').classList.add('green-background')
      this.SearchItem = []
    },
    Reload () {
      this.loading = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'userTilbuds', salesPerson: this.salesPerson}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            var restilbud = res.tilbud
            var tilbuditems = []
            tilbuditems = restilbud.filter((item) => {
              return item.is_darft !== '1'
            })
            this.items = tilbuditems
            var varthis = this
            this.items.forEach(function (item) {
              varthis.customers.push(item.firstname)
              var address = ''
              address = varthis.allcustomerinfo.filter((a) => {
                return a.firstname === item.firstname
              })
              item['address'] = address.mailingstreet + ' ' + address.mailingzip + ' ' + address.mailingcity
              if (item['address'] === 'undefined undefined undefined') {
                item['address'] = 'Address empty'
              }
            })
            const unique = (value, index, self) => {
              return self.indexOf(value) === index
            }
            this.allcustomerfilter = this.customers.filter(unique)
            if (this.search !== '') {
              this.updateSearch()
            } else {
              this.SearchItem = this.filterSearch(this.items)
            }
            if (this.activeyear === '') {
              var latestyear = new Date().getFullYear()
              this.filteryear(latestyear)
            }
            if (this.customerid !== '' && typeof this.customerid !== 'undefined') {
              this.updateSearchcustomer(this.customerid)
            }
            this.disableStatusSelection = false
            this.loading = false
          },
          response => {
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        )
    },
    onClick (item, i) {
      item.index = i
    },
    showpdfoffer (urlpdf) {
      // if (urlpdf === null) {
      //   this.urlofferpdf = urlpdf
      // }
      this.urlofferpdf = urlpdf
      this.$refs.seeoffer.show()
    },
    hidepdfoffer () {
      this.$refs.seeoffer.hide()
    },
    filterSearch (item) {
      return item
    },
    updateSearch (a = '') {
      if (a === 'searc') {
        var items = []
        items = this.items.filter((item) => {
          return item.firstname.toLowerCase().includes(this.search.toLowerCase()) || item.lastname.toLowerCase().includes(this.search.toLowerCase()) || item.mobile.toLowerCase().includes(this.search.toLowerCase()) || item.reference_number.toLowerCase().includes(this.search.toLowerCase())
        })
        this.SearchItem = this.filterSearch(items)
      }
      if (a.length >= 1) {
        var itemscustomer = []
        var varthis = this
        if (a.length > 0) {
          varthis.items.filter((b) => {
            a.forEach(itemc => {
              if (itemc === b.firstname) {
                itemscustomer.push(b)
              }
            })
          })
        }
        if (a.length > 0) {
          this.SearchItem = itemscustomer
        } else {
          this.SearchItem = this.SearchItem
        }
      }
      if (a.length === 0) {
        var latestyear = new Date().getFullYear()
        this.filteryear(latestyear)
      }
    },
    updateSearchcustomer (item) {
      var itemscustomers = []
      if (item !== '' && this.minboligv2 !== 'minboligv2') {
        itemscustomers = []
        this.items.forEach((b) => {
          if (b.cid === item) {
            itemscustomers.push(b)
          }
        })
        this.filteredItemsbitrix = []
        if (itemscustomers.length > 0) {
          this.SearchItem = itemscustomers
        } else {
          this.SearchItem = this.SearchItem
        }
      } else {
        itemscustomers = []
        itemscustomers = this.openjobs.filter((z) => {
          return z.CONTACT_ID.toString() === item
        })
        this.SearchItem = []
        if (itemscustomers.length > 0) {
          this.filteredItemsbitrix = itemscustomers
        } else {
          this.filteredItemsbitrix = this.filteredItemsbitrix
        }
        this.showboligoffer = true
      }
    },
    seeMessages (id) {
      this.$router.push('/messages/inbox?customerId=' + id)
    },
    toggleSort (statusDate) {
      var items = []
      var order
      if (statusDate === '1') {
        order = this.oldestFirst ? 1 : -1
        items = this.items.sort(function (a, b) {
          a = new Date(a.appointment_date + ' ' + a.id_times)
          b = new Date(b.appointment_date + ' ' + b.id_times)
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.oldestFirst = !this.oldestFirst
      } else if (statusDate === '2') {
        order = this.ascending ? 1 : -1
        items = this.items.sort(function (a, b) {
          a = a.id_appointment_status
          b = b.id_appointment_status
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.ascending = !this.ascending
      } else if (statusDate === '3') {
        order = this.oldestFirst ? 1 : -1
        items = this.items.sort(function (a, b) {
          a = new Date(a.tilbud_date)
          b = new Date(b.tilbud_date)
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.oldestFirst = !this.oldestFirst
      } else if (statusDate === '4') {
        order = this.oldestFirst ? 1 : -1
        items = this.items.sort(function (a, b) {
          a = new Date(a.datereserve)
          b = new Date(b.datereserve)
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.oldestFirst = !this.oldestFirst
      } else {

      }
    },
    toggleFilter (status) {
      var items = []
      var filtered = []
      if (status.length !== 0) {
        for (var i = 0; i < status.length; i++) {
          if (status[i] === '9') {
            items = this.items.filter((item) => {
              return item.privatecustomer.includes('1')
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] === '10') {
            items = this.items.filter((item) => {
              return item.privatecustomer.includes('0')
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] < 7 || status[i] === '100') {
            var statuscatcher = parseInt(status[i])
            items = this.items.filter((item) => {
              return item.tilbudstatus === statuscatcher
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] === '8') {
            items = this.items.filter((item) => {
              return item.id_appointment.length > 1
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] === '7') {
            items = this.items.filter((item) => {
              return item.id_appointment.length < 1
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] === '12') {
            items = this.items.filter((item) => {
              return item.tilbudstatus === 6
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
        }
        this.SearchItem = this.filterSearch(filtered)
      } else {
        this.SearchItem = this.filterSearch(this.items)
      }
    },
    UpdateTilbud (files) {
      this.files = files
    },
    mailSupport (cid) {
      this.$router.push('/inbox?cid=' + cid)
    },
    handleSubmitReminder (item) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var smsemail = item.remiderappid.smsemail
      var dateReminder = this.datereminder
      var descp = item.remiderappid.descp
      if (dateReminder === '' || dateReminder === null) {
        let obj = {
          title: 'Påmindelse Dato ?',
          message: '',
          type: 'error'
        }
        this.$refs.simplert.openSimplert(obj)
        return
      }
      this.show = true
      var data = {operation: 'change_reminder_meeting', salesPerson: this.salesPerson, smsemail: smsemail, appointmentid: item.id_appointment, date_reminder: dateReminder, descp: descp}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.show = false
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.Reload()
              document.getElementById('setReminderb' + item.id_appointment).click()
              this.$refs.simplert.openSimplert(obj)
              this.datereminder = null
            } else {
              alert(res.message)
              this.isLoadingDato = false
            }
          },
          response => {
            this.show = false
            alert('error')
          }
        )
    },
    deletedrafttilbud (item) {
      this.loading = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {
        operation: 'delTilbud',
        salesPerson: this.salesPerson,
        tilbud_id: item.appid,
        offer_id: item.id
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.loading = false
            if (res.success) {
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    loadComment () {
      this.loading = true
      var data = {operation: 'loadcomment', salesPerson: this.salesPerson, cid: this.kundeitem.contactid}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.komments = res
            this.loading = false
          },
          response => {
            alert('error')
            this.loading = false
          }
        )
    },
    showMeetingTilbud (item) {
      this.$router.push('/tilbud/tilbud-historie?app=' + item.id_appointment)
    },
    showMeetingDetailsAflysetext (item) {
      this.modalShowAflyseText = true
      this.AflyseText = item.ticketsolution
      this.AflyseTexttitle = item.ticketstatus
    },
    showMeetingDetailsCommenttext (item) {
      this.modalShowCommentText = true
      this.CommentText = item.comment_to_partner
    },
    showMeetingDetailsCommentCustomertext (item) {
      this.modalShowCommentCustomerText = true
      this.CommentCustomerText = item.comment_to_customer
    },
    showMeetingDetailsDate  (item) {
      this.Datosetitle = 'Ændring af tid for kunde: ' + item.firstname + ' ' + item.lastname
      this.modalShowDato = true
      this.Datoeid = item
      this.textDatoReason = ''
      this.isLoadingDato = false
      var select = document.getElementById('select_time')
      for (var i = 0; i < select.length; i++) {
        var option = select.options[i]
        if (option.text === item.id_times) {
          this.timeDato = option.value
        }
      }
    },
    changeStatus (value, item) {
      this.statusValue = value
      this.statusItem = item
      this.disableStatusSelection = true
      // Price feedback
      if (value === '2' || value === '3' || value === '4') {
        if (item.pricefeedback === '0') {
          this.feedbackLoading = true
          this.showPriceFeedBackModal()
        } else {
          this.updateStatus(value, item)
        }
      // Survey feedback
      } else if (value === '5' || value === '6' || value === '100') {
        this.feedbackLoading = true
        this.showSurveyModal()
      } else {
        this.updateStatus(value, item)
      }
    },
    updateStatus (value, item) {
      this.modalPriceFeedback = false
      this.modalSurvey = false
      this.isLoadingReview = true
      var dataPartner = {operation: 'customer_status_henttilbud', salesPerson: this.salesPerson, status: value, cid: item.id_appointment, descp: this.surveyDescription}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.isLoadingReview = false
            this.surveyDescription = ''
            var infoType = ''
            if (res.success) {
              infoType = 'success'
            } else {
              infoType = 'info'
            }
            let obj = {
              title: res.message,
              message: '',
              type: infoType,
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
            this.Reload()
          },
          response => {
            console.log('Error in updateStatus()', response)
          }
        )
    },
    showMeetingDetailsAflyse (item) {
      this.Aflysetitle = 'Er mødet med ' + item.firstname + ' ' + item.lastname + ' aflyst af kunden?'
      this.modalShowAflyse = true
      this.Aflyseid = item
      this.textAflyseReason = ''
      this.isLoadingAflyse = false
    },
    filterItem (items) {
      var newItem = []
      for (var iteme in items) {
        newItem.push(items[iteme])
      }
      return newItem
    },
    showMeetingDetails (item) {
      this.meetingShow = !this.meetingShow
      this.sampleMeeting.id = item.id
      this.sampleMeeting.type = item.type
      this.sampleMeeting.estimate = item.estimate
      this.sampleMeeting.city = item.city
      this.sampleMeeting.postnummer = item.postnummer
      this.sampleMeeting.price = item.price
      this.sampleMeeting.date = item.date
    },
    getAcceptedOfferPrice (offerid, projectid, contactid, calculationid = 0) {
      this.selectedArr = {}
      this.totaloffer = 0
      this.innerloading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPriceMinbolig?project_id=' + projectid + '&contact_id=' + Number(contactid) + '&calculation_id=' + calculationid, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          var filteredresult = {}
          let result = res.result.filter(l => {
            return Number(l.PARTNER_ID) === Number(this.haaId) && Number(l.OFFER_ID) === Number(offerid)
          })
          result.forEach(y => {
            if (!filteredresult[y.JOB_INDUSTRY]) {
              filteredresult[y.JOB_INDUSTRY] = []
              filteredresult[y.JOB_INDUSTRY].push(y)
            } else {
              filteredresult[y.JOB_INDUSTRY].push(y)
            }
            this.totaloffer += Number(y.TOTALVAT)
          })
          this.selectedArr = filteredresult
          this.innerloading = false
        },
        response => {
          this.loading = false
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    gettaskbitrix () {
      this.$http.get(this.$bitrixapi + 'industries/full', { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var industryname = {}
            res.data.forEach(l => {
              industryname[l.BRANCHE_ID] = l.BRANCHE
            })
            this.itemsjobindustry = industryname
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    getallwizardproduct () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
      }
      this.$http.get(this.$bitrixapi + 'partner/wizard/all', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          res.forEach(n => {
            this.primaryproductindustryname[n.producttypeid] = n.producttype
          })
        },
        err => {
          var error = err.body.message
          this.$message.error(error)
        })
    },
    closemodaloffer () {
      this.selectedArr = {}
      this.totaloffer = 0
      this.seeselectedoffer = false
    },
    openmodaloffer () {
      this.seeselectedoffer = true
      this.innerloading = true
    }
  }
}
</script>
<style lang="less">
.dg-content{
  white-space:pre-wrap;
}
.custom-control-input {
      position: unset;
    z-index: 1;
    opacity: 1;
    margin-right: 14px;
}
#offerhistory .offerbilagicon.outlined-standard-button:hover {
  fill: #fff;
}
.image {
    width: 200px;
    height: 200px;
    background-size: contain;
    cursor: pointer;
    margin: 10px;
    border-radius: 3px;
}
.field-input {
  border-radius: 0!important;
  background: rgba(230, 234, 235, 0.5)!important;
  border:0!important;
}
#offerhistory .loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
#offerhistory .loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
#offerhistory .loader:before,
.loader:after {
  position: absolute;
  content: '';
}
#offerhistory .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
#offerhistory .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.prisverslag .modal-content {
  min-height: 80vh;
}
/* .meetingSort {
} */
.searchContainer {
  position: relative;
  overflow: hidden;
}
.searchIcon {
  padding: 0.5rem;
}
.searchBox {
  border: 0;
  flex: 1;
  outline:none;
}
#m2mtilbud .sm-col-10{
    width: 83.33333%;
  }
</style>



// WEBPACK FOOTER //
// StandardTilbudhistory.vue?0f298d00